import React, { useEffect, useRef } from "react";
import WaveSurfer from "wavesurfer.js";

const WaveFormRecorded = ({
  blobURL, className = "", setAudioFinished
}) => {
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  

  useEffect(() => {
    if (blobURL && waveformRef.current) {
      if (wavesurfer.current) {
        wavesurfer.current.destroy();
      }

      wavesurfer.current = WaveSurfer.create({
        container: waveformRef.current,
        waveColor: "#B2EA47",
        progressColor: "#3b82f6",
        barWidth: 2,                  
        barRadius: 2, 
        barHeight:4,
        height: 50,
        responsive: true,
        plugins: [],
      });

      wavesurfer.current.load(blobURL);

      wavesurfer.current.on('finish', () => {
        setAudioFinished(true);
      });
    }

    return () => {
      if (wavesurfer.current) {
        wavesurfer.current.destroy();
        wavesurfer.current = null;
      }
    };
  }, [blobURL]);




  const playPauseRecording = (e) => {
    wavesurfer.current.playPause();
  }

  if (!blobURL) return null;

  return (
    <div className="row p-3 recorded-wave-container">
      <div className="col-1">
        <span className="play-pause-button recorded-waveform-button m-0">
          <i
            className="fa fa-play text-success"
            onClick={playPauseRecording}
          ></i>
        </span>
      </div>

      <div className="col-11">
        <div className={`recorded-waveform-container ${className}`}>
          <div className="recorded-waveform-visual">
            <div
              ref={waveformRef}
              className="recorded-waveform-wave"
              tabIndex={-1}
              style={{
                outline: 'none'
              }}
            />

            <div className="waveform-base-line" style={{ top: "53%" }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaveFormRecorded;
